import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_newTable = _resolveComponent("newTable")!
  const _component_tool_tip = _resolveComponent("tool-tip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "title" }, "Activity Risk", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
          }, [
            _createElementVNode("button", {
              class: _normalizeClass(["flex", _ctx.tableRow.length == 0 ? 'btndisabled pointer-events-none' : 'filterButton'])
            }, [
              (_ctx.tableRow.length == 0)
                ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                : (_openBlock(), _createElementBlock("img", _hoisted_5)),
              _cache[1] || (_cache[1] = _createTextVNode(" Filters "))
            ], 2)
          ])
        ])
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mt-3 text-xs" }, " Identify, manage, and monitor risks in key activities or processes performed by various teams across the organization. ", -1)),
    _createElementVNode("div", null, [
      _createVNode(_component_newTable, {
        tableRowData: _ctx.tableRow,
        headersData: _ctx.headers,
        openPopup: false,
        navigate: true,
        loadData: _ctx.dataLoading
      }, null, 8, ["tableRowData", "headersData", "loadData"]),
      (_ctx.toolTipActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}